<template>
    <div class="subscription-vehicle-switch mb-5">
        <div class="row">
            <div class="col-12">
                <h5 class="mb-4">{{ $t('cdb.subscriptions.vehicle_switch') }}</h5>
            </div>
            <div class="col-12 mb-4">
                <span class="badge badge-secondary">{{ subscriptionData.tier_title }}</span>
            </div>
            <div v-if="openRequest" class="col-12 mb-3">
                <span>{{ $t('cdb.subscriptions.vehicle_switch_requested') }}</span>
            </div>
            <div v-else class="col-12 mb-3">
                <b-button v-if="vehicleSwitchable" variant="primary" class="mr-3" @click="openVehicleSwitchModal">{{ $t('cdb.subscriptions.vehicle_switch_button') }}</b-button>
                <span v-if="!vehicleSwitchable">{{ $t('cdb.subscriptions.vehicle_switch.not_available') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus';
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import { BButton } from 'bootstrap-vue';

export default {
    name: 'SubscriptionVehicleSwitch',
    components: {
        DataEntryColumn,
        BButton,
    },
    props: {
        subscriptionData: {
            type: Object,
            required: true
        }
    },
    methods: {
        openVehicleSwitchModal(){
            EventBus.$emit('init-vehicle-switch', this.subscriptionData);
        }
    },
    computed: {
        vehicleSwitchable() {
            if (this.subscriptionData.tier_vehicles){
                return this.subscriptionData.tier_vehicles.length > 0;
            } else {
                return false
            }
        },
        openRequest() {
            return this.subscriptionData.timestamps.vehicle_change_request ? true : false
        }
    }
}
</script>

<style scoped lang="scss"></style>
